@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.container {
  --side-padding: 16px;

  .revision {
    max-height: 80vh;
    margin-bottom: 6px;
    border-radius: 16px;
    display: flex;
    background: var(--neutral-0);
    @include shadow-3;
    flex-direction: column;
    overflow: hidden;
    .contentPreview {
      :global(.ProseMirror) {
        > :first-child {
          padding-top: 0 !important;
        }

        > :last-child {
          padding-bottom: 0 !important;
        }
      }
    }

    @include for-phone-only {
      border-radius: 6px;
      background: transparent;
      box-shadow: none;
      gap: 10px;
      max-height: calc(100vh - 56px);
      margin-bottom: 0;
    }
  }

  .stepper {
    margin-top: 4px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

.content {
  padding: 16px var(--side-padding) 0 var(--side-padding);
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;

  &.withDivider {
    border-bottom: 1px solid var(--neutral-10);
  }

  .closeIcon {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 1;
    border-radius: 14px;
    background: var(--light-100);

    &:hover {
      background: var(--neutral-5-alt);
    }
  }

  @include for-phone-only {
    @include blur(25px);
    border-radius: 6px;
    background: var(--light-100);
    padding: 16px var(--side-padding);
  }
}
